<lib-card class="d-flex h-100">
    <div class="d-flex flex-column gap-3">
        @if (displayItem.ParentID) {
            <p class="typography-label-large-strong">
                {{ displayItem | method: DisplayFirstNameAndLastInitial}}
            </p>
        } @else {
            <p
                class="typography-label-large-strong"
                i18n="@@CommonAnonymous">
                Anonymous
            </p>
        }
        <div class="d-flex flex-column gap-2">
            <div class="d-flex justify-content-between align-items-center">
                <lib-star-rating
                    [ratingValue]="displayItem.RatingPercentage"
                    [kind]="StarRatingViewKind.CardStars"></lib-star-rating>
                <p class="typography-body-small neutral-800">{{ displayItem.CreatedDate | formatDate: 'yearmonth' }}</p>
            </div>
            <p
                #review
                class="typography-body-medium">
                {{ displayItem.ReviewBody }}
            </p>
            <lib-expandable-text
                [targetText]="review"
                [numberOfLines]="4"></lib-expandable-text>
        </div>
    </div>
</lib-card>
